export enum Contribution {
  PERCENTAGE = 'percentage',
  DOLLAR = 'dollar'
}
